mutation RequestImageUploadUrl(
  $contentType: String!
  $contentLength: Int!
) {
  upload: StreamToolsRequestImageUploadUrl(
    contentType: $contentType
    contentLength: $contentLength
  ) {
    uploadUrl
    publicUrl
    expiresAt
    assetId
    s3Key
  }
}
